module.exports = __webpack_public_path__ + "61dc057728dfa7ad74827e602f34e8fa.gif";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/loading-simple.gif
// module id = 240
// module chunks = 0